export const CATEGORY_SUGGESTIONS = [
  '차단기',
  '회로보호기',
  '퓨즈',
  '퓨즈홀더',
  '컨택터',
  '접촉기',
  '릴레이',
  'PLC 릴레이',
  'PLC/제어기',
  'PLC/자동화 부품',
  'I/O 모듈',
  '통신모듈',
  '단자대',
  '점퍼',
  '전원장치',
  '전원공급장치',
  '저항',
  '케이블',
  '통신케이블',
  '커넥터',
  '센서',
  '산업용 PC',
  'DC 퓨즈홀더',
  '기타',
]

export const MANUFACTURER_SUGGESTIONS = [
  'ABB',
  'Schneider Electric',
  'Honeywell',
  'LS ELECTRIC',
  'Phoenix Contact',
  'Weidmüller',
  'Eaton',
  'B&R',
  'HINODE',
  'KACON',
  'Bourns',
  'Littelfuse',
  'SEOIL',
]

export const UNIT_SUGGESTIONS = ['개', 'EA', 'SET', 'M', 'ROLL', 'BOX']

export const USAGE_STATUSES = [
  { value: 'ACTIVE', label: '사용중' },
  { value: 'DISCONTINUED', label: '단종' },
  { value: 'STANDBY', label: '예비' },
]

export const SEARCH_FIELDS = [
  { value: 'all', label: '통합검색' },
  { value: 'model', label: '모델명' },
  { value: 'manufacturer', label: '제조사' },
  { value: 'name', label: '품명' },
  { value: 'category', label: '분류' },
  { value: 'partCode', label: '관리번호' },
]

export const VERIFICATION_LABELS = {
  UNVERIFIED: '검수필요',
  VERIFIED: '검수완료',
  NEEDS_REVIEW: '검수필요',
  ESTIMATED: '검수필요',
  CONFIRMED: '검수완료',
}

export const VERIFICATION_OPTIONS = [
  { value: 'UNVERIFIED', label: '검수필요' },
  { value: 'VERIFIED', label: '검수완료' },
]

export const REVIEW_SEARCH_FIELDS = [
  { value: 'all', label: '통합검색' },
  { value: 'partCode', label: '관리번호' },
  { value: 'model', label: '모델' },
  { value: 'name', label: '품명' },
  { value: 'manufacturer', label: '제조사' },
]

export const REVIEW_TABS = [
  { value: 'needed', label: '검수 필요' },
  { value: 'qty', label: '수량 미확인' },
  { value: 'spec', label: '사양 미확인' },
  { value: 'done', label: '검수완료' },
]

export const VERIFICATION_FILTERS = [
  { value: 'all', label: '전체' },
  { value: 'needed', label: '검수 필요' },
  { value: 'qty', label: '수량 미확인' },
  { value: 'spec', label: '사양 미확인' },
  { value: 'done', label: '검수 완료' },
]

export const PART_SIZE_OPTIONS = ['대', '중', '소']

export const STORAGE_METHOD_OPTIONS = ['랙 직접', '단독박스·랙', '공용박스·소형칸']

export const MODEL_MATCH_OPTIONS = [
  { value: 'MATCH', label: '일치' },
  { value: 'MISMATCH', label: '불일치' },
]

export function modelMatchLabel(value) {
  if (value === 'MATCH') return '일치'
  if (value === 'MISMATCH') return '불일치'
  return '-'
}

export function isVerifiedStatus(value) {
  return value === 'VERIFIED' || value === 'CONFIRMED'
}

export function usageStatusLabel(value) {
  return USAGE_STATUSES.find((item) => item.value === value)?.label || value || '-'
}

export const STOCK_FILTERS = [
  { value: 'all', label: '전체' },
  { value: 'ok', label: '재고 있음' },
  { value: 'low', label: '재고 부족' },
  { value: 'out', label: '재고 없음' },
  { value: 'unverified', label: '수량 미확인' },
]

export const TX_TYPE_FILTERS = [
  { value: 'all', label: '전체' },
  { value: 'IN', label: '입고' },
  { value: 'OUT', label: '출고' },
  { value: 'OPENING', label: '초기재고' },
  { value: 'ADJUSTMENT', label: '재고조정' },
  { value: 'MERGE', label: '병합' },
]

export const PART_REQUEST_TYPES = [
  { value: 'EXISTING_PART', label: '기존 재고 품목' },
  { value: 'NEW_ITEM', label: '재고에 없는 품목' },
]

export const PART_REQUEST_TYPE_FILTERS = [
  { value: 'all', label: '전체' },
  ...PART_REQUEST_TYPES,
]

export const PART_REQUEST_STATUSES = [
  { value: 'REQUESTED', label: '요청', tone: 'pending' },
  { value: 'REVIEWING', label: '검토중', tone: 'warn' },
  { value: 'APPROVED', label: '승인', tone: 'in' },
  { value: 'REJECTED', label: '반려', tone: 'danger' },
  { value: 'ORDERED', label: '구매중', tone: 'warn' },
  { value: 'COMPLETED', label: '완료', tone: 'ok' },
]

export const PART_REQUEST_STATUS_FILTERS = [
  { value: 'all', label: '전체' },
  ...PART_REQUEST_STATUSES.filter((item) => item.value !== 'REQUESTED').map(({ value, label }) => ({
    value,
    label,
  })),
]

export const PART_REQUEST_STATUS_ACTIONS = [
  { value: 'APPROVED', label: '승인', button: 'btn--primary' },
  { value: 'REJECTED', label: '반려', button: 'btn--danger' },
  { value: 'ORDERED', label: '구매중', button: 'btn--ghost' },
  { value: 'COMPLETED', label: '완료', button: 'btn--ghost' },
]

export function requestTypeLabel(value) {
  return PART_REQUEST_TYPES.find((item) => item.value === value)?.label || value || '-'
}

export function requestStatusLabel(value) {
  return PART_REQUEST_STATUSES.find((item) => item.value === value)?.label || value || '-'
}

export function requestStatusTone(value) {
  return PART_REQUEST_STATUSES.find((item) => item.value === value)?.tone || 'pending'
}

export function requestItemName(request) {
  return request?.itemName || request?.partName || request?.model || '-'
}

export const STORAGE_KEYS = {
  token: 'ensight_inventory.token',
  user: 'ensight_inventory.user',
  persist: 'ensight_inventory.persist',
}
